import React, { Component } from "react";
import { connect } from "react-redux";
import { Form } from "react-form";
import { withRouter, Link } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import SettingsIcon from "@material-ui/icons/Settings";
import Close from "@material-ui/icons/Close";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";
import TableBody from "@material-ui/core/TableBody";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import CreateIcon from "@material-ui/icons/Create";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import TableRow from "@material-ui/core/TableRow";
import CircularProgress from "@material-ui/core/CircularProgress";
import DeleteIcon from "@material-ui/icons/Delete";
import Table from "@material-ui/core/Table";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import CloudDownload from "@material-ui/icons/CloudDownload";
import CloudUpload from "@material-ui/icons/CloudUpload";
import GetApp from "@material-ui/icons/GetApp";
import Chip from "@material-ui/core/Chip";
import Popover from "@material-ui/core/Popover";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import MuiSwitch from "@material-ui/core/Switch";
import NumberFormat from "react-number-format";

import AppContainer from "../common/AppContainer";
import Select from "../common/Select";
import TextField from "../common/TextField";
import ContactDialog from "./ContactDialog";
import { createSelector } from "../common/orm";
import Switch from "../common/Switch";
import * as authActions from "../auth/actions";
import WarningDialog from "../common/WarningDialog";
import FileInput from "../common/FileInput";
import HelpLabel from "../common/HelpLabel";
import EnhancedTableHead from "../common/EnhancedTableHead";
import TablePaginationActionsWrapped from "../common/Paginator";
import CustomTableCell from "../common/TableCell";
import { ContactField, ContactRecord, ContactRecordField } from "../page/models";
import { getCSRFToken } from '../common/Csrf'

const styles = (theme) => ({
    marginLeft: {
        marginLeft: 16,
    },
    deleteWidth: {
        minWidth: 34,
        width: 34,
        marginRight: 8,
        marginTop: 2,
        marginBottom: 2,
    },
    centerAlign: {
        textAlign: "center",
    },
    flex: {
        flex: 1,
    },
    nowrap: {
        whiteSpace: "nowrap",
    },
    minWidth2: {
        width: 400,
    },
    floatLeft: {
        float: "left",
    },
    floatRight: {
        float: "right",
    },
    button: {
        marginTop: 32,
        marginLeft: "auto",
        marginRight: "auto",
        display: "table",
    },
    ellipsis: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 15,
        WebkitBoxOrient: "vertical",
    },
    truncate: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: 200,
    },
    iconbutton: {
        margin: "0 8px",
    },
    tableContainer: {
        width: "100%",
        overflow: "auto",
        [theme.breakpoints.up("lg")]: {
            maxHeight: "calc(100vh - 285px)",
        },
    },
});

const getContactFields = createSelector((schema) => {
    return schema.ContactField.all().orderBy("order").toModelArray();
});

const getMasterContacts = createSelector((schema) => {
    return schema.ContactRecord.all().toModelArray();
});

class Contacts extends Component {
    state = {
        order: "desc",
        orderBy: null,
        rowsPerPage: 25,
        page: 0,
        dialogOpen: false,
        activeContact: null,
        deleteDialogOpen: false,
        deleteDialogConfirmAction: null,
        open: false,
        totalCount: 0,
        tableLoading: false,
        buttonLoading: false,
        searchLoading: false,
        searchedContacts: [],
        lastSearchValues: null,
        // goBack: false
        newContactId: null,
        menuAnchorEl: null,
        exportLoading: false,
        exportMenuAnchor: null,
        recordsMap: {},
        recordsPopoverAnchor: null,
        recordsPopoverItems: [],
    };

    componentDidMount() {
        const { authState, /*ormContactRecordCreate, , ormContactRecordFieldCreate, contact_fields,*/ ormContactRecordLoadDetailChild } = this.props;
        const params = new URLSearchParams(this.props.location.search);
        //const filters = params.get("new");
        const filters2 = params.get("edit");
        var comp = this;
        // Not used?
        /*if (filters && filters === "true") {
            this.setState({buttonLoading: true});
            ormContactRecordCreate({
                city_id: authState.user.city_id
            }).then(record => {
                let i = 0;
                let j = 0;
                contact_fields.forEach(function(cf) {
                    if (cf.is_global) {
                        ormContactRecordFieldCreate({
                            contactrecord_id: record.id,
                            contactfield_id: cf.id
                        }).then(z => {
                            j++;
                            if (i === j) {
                                // Grab the newly created columns
                                comp.loadTotalRecords();
                                ormContactRecordLoadDetailChild(record.id, function(what) {
                                    comp.setState({ dialogOpen: true, activeContact: what[0], buttonLoading: false });
                                });
                            }
                        });
                        i++;
                    }
                });
            });
        } else */ if (filters2) {
            this.setState({ buttonLoading: true });
            ormContactRecordLoadDetailChild(parseInt(filters2), function (what) {
                comp.setState({ dialogOpen: true, activeContact: what[0], buttonLoading: false /* goBack: true*/ });
            });
        }

        // Reload the fields here because if the is_global flag is changed in the update viewset there is no way to call reload after an update
        if (authState && authState.user) {
            this.loadTotalRecords();
            this.dynamicLoading(0, 25, "asc", null);
            fetch('/excel/contacts/records-map')
                .then(r => r.ok ? r.json() : Promise.reject(r.status))
                .then(data => this.setState({ recordsMap: data }))
                .catch(err => console.error('contacts-records-map failed:', err));
        }
    }

    componentDidUpdate(prevProps) {
        const { authState } = this.props;
        if (authState && authState !== prevProps.authState) {
            this.loadTotalRecords();
            this.dynamicLoading(0, 25, "asc", null);
            fetch('/excel/contacts/records-map')
                .then(r => r.ok ? r.json() : Promise.reject(r.status))
                .then(data => this.setState({ recordsMap: data }))
                .catch(err => console.error('contacts-records-map failed:', err));
        }
    }

    loadTotalRecords = (_filters) => {
        const { authState, history, authLogout } = this.props;
        var component = this;

        fetch("/count/contacts", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": getCSRFToken(),
            },
        }).then((e) => {
            if (e.status === 401 || e.status === 403) {
                authLogout(authState, history);
            } else if (e.status !== 500) {
                e.json().then((data) => {
                    component.setState({ totalCount: data.totalCount });
                });
            }
        });
    };

    dynamicLoading = (_page, _rowsPerPage, _order, _orderBy) => {
        const { ormContactRecordReloadDynamic } = this.props;
        var { order, orderBy, rowsPerPage, page } = this.state;
        var component = this;
        // These if/elses are kind messy but apparently you can't overwrite _page, etc.
        var p, r, o, ob;
        if (_page !== undefined) p = _page;
        else p = page;
        if (_rowsPerPage !== undefined) r = _rowsPerPage;
        else r = rowsPerPage;
        if (_order !== undefined) o = _order;
        else o = order;
        if (_orderBy !== undefined) ob = _orderBy;
        else ob = orderBy;

        var str = "";

        this.setState({ tableLoading: true });
        str += "&contacts=true&count=" + r + "&offset=" + r * p + "&order=" + o + "&order_by=" + encodeURIComponent(ob);
        ormContactRecordReloadDynamic(str).then(() => {
            component.setState({ tableLoading: false });
        });
    };

    searchForm(values) {
        var { authState, history, authLogout } = this.props;

        var filt1 = values.filter1;
        if (filt1) filt1 = filt1.trim();
        var filt2 = values.filter1;
        if (filt2) filt2 = filt2.trim();
        var filt3 = values.filter1;
        if (filt3) filt3 = filt3.trim();

        if (!filt1 && !filt2 && !filt3) {
            this.setState({ searchLoading: false, searchedContacts: [] });
            return;
        }

        this.setState({ searchLoading: true, results: [], page: 0, lastSearchValues: values });
        fetch("/contacts/search", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": getCSRFToken(),
            },
            body: JSON.stringify(values),
        }).then((e) => {
            if (e.status === 401 || e.status === 403) {
                authLogout(authState, history);
            } else {
                e.json().then((data) => {
                    this.setState({ searchLoading: false, searchedContacts: data });
                });
            }
        });
    }

    exportContactsTable = () => {
        const { authState } = this.props;
        if (this.state.exportLoading) return;
        this.setState({ exportLoading: true });
        fetch('/excel/contacts/export')
            .then(r => {
                if (!r.ok) throw new Error(r.status);
                return r.blob();
            })
            .then(blob => {
                const today = new Date();
                const mm = String(today.getMonth() + 1).padStart(2, '0');
                const dd = String(today.getDate()).padStart(2, '0');
                const yyyy = today.getFullYear();
                const cityName = authState && authState.user && authState.user.city_name ? authState.user.city_name : 'City';
                const filename = `${cityName} Master Contacts (use for import) ${mm}-${dd}-${yyyy}.xlsx`;
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            })
            .catch(err => console.error('contacts table export failed:', err))
            .finally(() => this.setState({ exportLoading: false }));
    };

    exportWithRecords = async () => {
        const { searchedContacts, exportLoading } = this.state;
        const { authState, history, authLogout } = this.props;
        if (exportLoading) return;
        this.setState({ exportLoading: true });
        try {
            const contactIds = searchedContacts.length > 0 ? searchedContacts.map(c => c.id) : [];
            const res = await fetch('/excel/contacts/export-with-records', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCSRFToken() },
                body: JSON.stringify({ contact_ids: contactIds }),
            });
            if (res.status === 401 || res.status === 403) { authLogout(authState, history); return; }
            const data = await res.json();

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Master Contacts');
            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            const maxRecords = data.contacts.reduce((max, c) => Math.max(max, c.records.length), 0);
            const headers = [
                ...data.field_names,
                ...Array.from({ length: maxRecords }, (_, i) => `Record ${i + 1}`),
            ];

            worksheet.addRow(headers);
            const headerRow = worksheet.getRow(1);
            headers.forEach((_, idx) => {
                const cell = headerRow.getCell(idx + 1);
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF990033' } };
                cell.alignment = { wrapText: true, horizontal: 'center' };
                worksheet.getColumn(idx + 1).width = 25;
            });

            for (const contact of data.contacts) {
                const rowValues = [
                    ...data.field_names.map(name => contact.fields[name] || ''),
                    ...Array(maxRecords).fill(''),
                ];
                const row = worksheet.addRow(rowValues);
                contact.records.forEach((record, i) => {
                    const cell = row.getCell(data.field_names.length + i + 1);
                    cell.value = { text: record.label, hyperlink: window.location.origin + record.url };
                    cell.font = { color: { argb: 'FF0563C1' }, underline: true };
                });
            }

            const today = new Date();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const yyyy = today.getFullYear();
            const filename = `${data.city_name} Master Contacts with Associated Records Export ${mm}-${dd}-${yyyy}.xlsx`;
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), filename);
        } finally {
            this.setState({ exportLoading: false });
        }
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
        this.dynamicLoading(page);
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: event.target.value, page: 0 });
        this.dynamicLoading(0, event.target.value);
    };

    handleRequestSort = (event, property, full_property) => {
        const orderBy = property;
        let order = "desc";

        if (this.state.orderBy === property && this.state.order === "desc") {
            order = "asc";
        }

        // Reset to page/rowsperpage if this happens
        this.setState({ order, orderBy, page: 0, rowsPerPage: 25 });
        this.dynamicLoading(0, 25, order, orderBy);
    };

    handleAddNewContact = () => {
        const { ormContactRecordCreate, authState, contact_fields, ormContactRecordFieldCreate, ormContactRecordLoadDetailChild } = this.props;
        var comp = this;
        this.setState({ buttonLoading: true });
        ormContactRecordCreate({ city_id: authState.user.city_id }).then((record) => {
            let i = 0;
            let j = 0;
            contact_fields.forEach(function (cf) {
                if (cf.is_global) {
                    ormContactRecordFieldCreate({ contactrecord_id: record.id, contactfield_id: cf.id }).then(() => {
                        j++;
                        if (i === j) {
                            comp.loadTotalRecords();
                            ormContactRecordLoadDetailChild(record.id, function (what) {
                                comp.setState({ dialogOpen: true, activeContact: what[0], buttonLoading: false, newContactId: record.id });
                            });
                        }
                    });
                    i++;
                }
            });
        });
    };

    render() {
        const {
            contact_fields,
            classes,
            master_contacts,
            ormContactRecordCreate,
            authState,
            ormContactRecordFieldCreate,
            ormContactRecordDelete,
            ormContactRecordFieldUpdate,
            ormContactRecordLoadDetailChild,
            authLogout,
            history
        } = this.props;
        const {
            order,
            orderBy,
            page,
            rowsPerPage,
            dialogOpen,
            activeContact,
            deleteDialogOpen,
            deleteDialogConfirmAction,
            open,
            totalCount,
            tableLoading,
            buttonLoading,
            searchLoading,
            searchedContacts,
            menuAnchorEl,
            recordsMap,
            recordsPopoverAnchor,
            recordsPopoverItems,
            // goBack
        } = this.state;

        var columnData = [
            { id: "actions", numeric: false, label: "Actions", allowSort: false, width: "20px" },
            { id: "records", numeric: false, label: "Associated Records", allowSort: false },
        ];
        contact_fields.forEach(function (cf) {
            if (cf.is_global) columnData.push({ id: cf.field_name, numeric: false, label: cf.field_name, allowSort: true });
        });

        var searching = searchedContacts.length > 0 ? searchedContacts : master_contacts;
        var searchingcount = searchedContacts.length > 0 ? searchedContacts.length : totalCount;

        return (
            <AppContainer authenticated>
                <Grid container spacing={2}>
                    {contact_fields.length === 0 &&
                        authState &&
                        authState.user &&
                        authState.user.is_city_admin === true &&
                        authState.user.contacts_read_only === false && (
                            <Grid item xs={12}>
                                <Button component={Link} to="/contacts/config" variant="contained" color="primary">
                                    <SettingsIcon />
                                    &nbsp;&nbsp;Configure Contact Fields
                                </Button>
                            </Grid>
                        )}
                    {contact_fields.length > 0 && (
                        <>
                            <Grid item xs={12}>
                                {buttonLoading && (
                                    <CircularProgress style={{ marginLeft: 100, marginBottom: -24 }} size={30} className={classes.progress} />
                                )}

                                {/* Small screen collapse to dropdown menu */}
                                <Hidden lgUp>
                                    {!buttonLoading && (
                                        <>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                style={{ float: "right", marginTop: 8 }}
                                                onClick={(e) => this.setState({ menuAnchorEl: e.currentTarget })}>
                                                <MoreVertIcon style={{ marginRight: 6 }} />
                                                Options
                                            </Button>
                                            <Menu
                                                anchorEl={menuAnchorEl}
                                                open={Boolean(menuAnchorEl)}
                                                onClose={() => this.setState({ menuAnchorEl: null })}>
                                                {authState && authState.user && authState.user.contacts_read_only === false && (
                                                    <MenuItem onClick={() => { this.setState({ menuAnchorEl: null }); this.handleAddNewContact(); }}>
                                                        <AddCircleOutlineIcon style={{ marginRight: 8 }} />
                                                        Add New Master Contact
                                                    </MenuItem>
                                                )}
                                                <MenuItem onClick={() => { this.setState({ menuAnchorEl: null }); this.exportContactsTable(); }}>
                                                    <CloudDownload style={{ marginRight: 8 }} />
                                                    Export All Contacts (use for import)
                                                </MenuItem>
                                                <MenuItem onClick={() => { this.setState({ menuAnchorEl: null }); this.exportWithRecords(); }}>
                                                    <GetApp style={{ marginRight: 8 }} />
                                                    Export Table View Contacts with Associated Records
                                                </MenuItem>
                                                {authState && authState.user && authState.user.is_city_admin === true && authState.user.contacts_read_only === false && (
                                                    <MenuItem onClick={() => this.setState({ menuAnchorEl: null, open: true })}>
                                                        <CloudUpload style={{ marginRight: 8 }} />
                                                        Import Contacts
                                                    </MenuItem>
                                                )}
                                                {authState && authState.user && authState.user.is_city_admin === true && authState.user.contacts_read_only === false && (
                                                    <MenuItem component={Link} to="/contacts/config" onClick={() => this.setState({ menuAnchorEl: null })}>
                                                        <SettingsIcon style={{ marginRight: 8 }} />
                                                        Configure Contact Fields
                                                    </MenuItem>
                                                )}
                                            </Menu>
                                        </>
                                    )}
                                </Hidden>

                                {/* Large screen*/}
                                <Hidden mdDown>
                                    {!buttonLoading && authState && authState.user && authState.user.contacts_read_only === false && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.handleAddNewContact}>
                                            <AddCircleOutlineIcon />
                                            &nbsp;&nbsp;Add New Master Contact
                                        </Button>
                                    )}
                                    {authState && authState.user && authState.user.is_city_admin === true && authState.user.contacts_read_only === false && (
                                        <>
                                            <Tooltip title="Configure Contact Fields">
                                                <IconButton
                                                    className={classes.iconbutton}
                                                    style={{ float: "right" }}
                                                    component={Link}
                                                    to="/contacts/config">
                                                    <SettingsIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Import Contacts">
                                                <IconButton
                                                    className={classes.iconbutton}
                                                    style={{ float: "right" }}
                                                    onClick={() => this.setState({ open: true })}>
                                                    <CloudUpload />
                                                </IconButton>
                                            </Tooltip>
                                        </>
                                    )}
                                    <Tooltip title="Export Contacts">
                                        <span style={{ float: "right" }}>
                                            <IconButton
                                                className={classes.iconbutton}
                                                disabled={this.state.exportLoading}
                                                onClick={(e) => this.setState({ exportMenuAnchor: e.currentTarget })}>
                                                <CloudDownload />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Menu
                                        anchorEl={this.state.exportMenuAnchor}
                                        open={Boolean(this.state.exportMenuAnchor)}
                                        onClose={() => this.setState({ exportMenuAnchor: null })}>
                                        <MenuItem onClick={() => { this.setState({ exportMenuAnchor: null }); this.exportContactsTable(); }}>
                                            <CloudDownload style={{ marginRight: 8 }} />
                                            Export All Contacts (use for import)
                                        </MenuItem>
                                        <MenuItem onClick={() => { this.setState({ exportMenuAnchor: null }); this.exportWithRecords(); }}>
                                            <GetApp style={{ marginRight: 8 }} />
                                            Export Table View Contacts with Associated Records
                                        </MenuItem>
                                    </Menu>
                                </Hidden>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper elevation={1} style={{ padding: "12px 16px", backgroundColor: "#f5f5f5", marginTop: 8 }}>
                                    <Form
                                        defaultValues={{ type: "AND" }}
                                        dontValidateOnMount={true}
                                        validateOnSubmit={true}
                                        onSubmit={(values) => this.searchForm(values)}>
                                        {(formApi) => (
                                            <form onSubmit={formApi.submitForm}>
                                                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
                                                    <div style={{ flexShrink: 0 }}>
                                                        <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", flexShrink: 0 }}>
                                                            <HelpLabel
                                                                inputLabel="Match Type"
                                                                showLabel={true}
                                                                helpText={
                                                                    <div>
                                                                        All searches use <b>contains</b> matching — results include any record where the field contains the term you entered.
                                                                        <br /><br />
                                                                        <b>AND</b> — all terms must match.
                                                                        <br />
                                                                        <b>OR</b> — at least one term must match.
                                                                    </div>
                                                                }
                                                            />
                                                            <div style={{ display: "inline-flex", alignItems: "center", paddingTop: 4 }}>
                                                                <Typography style={{ fontSize: "0.85rem" }}>AND</Typography>
                                                                <MuiSwitch
                                                                    checked={(formApi.values && formApi.values.type) === "OR"}
                                                                    onChange={(e) => formApi.setValue("type", e.target.checked ? "OR" : "AND")}
                                                                    color="secondary"
                                                                    size="small"
                                                                />
                                                                <Typography style={{ fontSize: "0.85rem" }}>OR</Typography>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <Tooltip title={formApi.values.filter1 || ""}>
                                                        <div style={{ flex: "1 1 140px", minWidth: 100 }}>
                                                            <TextField field="filter1" label="Contains Term 1" filterInput fullWidth />
                                                        </div>
                                                    </Tooltip>
                                                    <Tooltip title={formApi.values.filter2 || ""}>
                                                        <div style={{ flex: "1 1 140px", minWidth: 100 }}>
                                                            <TextField field="filter2" label="Contains Term 2" filterInput fullWidth />
                                                        </div>
                                                    </Tooltip>
                                                    <Tooltip title={formApi.values.filter3 || ""}>
                                                        <div style={{ flex: "1 1 140px", minWidth: 100 }}>
                                                            <TextField field="filter3" label="Contains Term 3" filterInput fullWidth />
                                                        </div>
                                                    </Tooltip>
                                                    <div style={{ flexShrink: 0, display: "flex", alignItems: "center", gap: 8, paddingBottom: 4 }}>
                                                        {searchLoading ? (
                                                            <CircularProgress size={24} />
                                                        ) : (
                                                            <>
                                                                <Button variant="contained" type="submit" color="primary">
                                                                    Search
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => {
                                                                        this.setState({ searchLoading: false, searchedContacts: [] });
                                                                        formApi.resetAll();
                                                                    }}>
                                                                    Clear
                                                                </Button>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </form>
                                        )}
                                    </Form>
                                </Paper>
                            </Grid>
                            <Grid item xs={12}>
                                {searchingcount > 25 && (
                                    <div
                                        style={{
                                            backgroundColor: "#dddddd",
                                            marginTop: 20,
                                            borderRadius: 1,
                                        }}>
                                        <TablePagination
                                            colSpan={columnData.length}
                                            count={searchingcount}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActionsWrapped}
                                        />
                                    </div>
                                )}
                                <div className={classes.tableContainer}>
                                    <Table className={classes.table} stickyHeader>
                                        <EnhancedTableHead
                                            columnData={!tableLoading ? columnData : []}
                                            order={order}
                                            orderBy={orderBy}
                                            onRequestSort={this.handleRequestSort}
                                        />
                                        <TableBody>
                                            {tableLoading && (
                                                <TableRow>
                                                    <CustomTableCell colSpan={0} className={classes.centerAlign} style={{ paddingBottom: 16 }}>
                                                        Loading Table Records...
                                                        <CircularProgress size={30} className={classes.progress} />
                                                    </CustomTableCell>
                                                </TableRow>
                                            )}
                                            {!tableLoading &&
                                                searching.map((n) => {
                                                    return (
                                                        <TableRow key={n.id} hover>
                                                            <CustomTableCell className={classes.nowrap}>
                                                                <Tooltip title="Edit Contact">
                                                                    <Button
                                                                        color="primary"
                                                                        onClick={() => {
                                                                            ormContactRecordLoadDetailChild(n.id, (what) => {
                                                                                this.setState({ dialogOpen: true, activeContact: what[0] });
                                                                            });
                                                                        }}
                                                                        className={classes.deleteWidth}>
                                                                        <CreateIcon color="primary" />
                                                                    </Button>
                                                                </Tooltip>
                                                                {authState && authState.user && authState.user.contacts_read_only === false && (
                                                                    <Tooltip title="Delete Contact">
                                                                        <Button
                                                                            color="primary"
                                                                            onClick={() =>
                                                                                this.setState({
                                                                                    deleteDialogOpen: true,
                                                                                    deleteDialogConfirmAction: n.id,
                                                                                })
                                                                            }
                                                                            className={classes.deleteWidth}>
                                                                            <DeleteIcon color="primary" />
                                                                        </Button>
                                                                    </Tooltip>
                                                                )}
                                                            </CustomTableCell>
                                                            <CustomTableCell key="records">
                                                                {(() => {
                                                                    const records = recordsMap[String(n.id)] || [];
                                                                    if (!records.length) return null;
                                                                    return (
                                                                        <Tooltip title="Displays all associated records tied to this contact">
                                                                            <Chip
                                                                                label={`${records.length} record${records.length !== 1 ? 's' : ''}`}
                                                                                size="small"
                                                                                color="primary"
                                                                                clickable
                                                                                onClick={(e) => this.setState({
                                                                                    recordsPopoverAnchor: e.currentTarget,
                                                                                    recordsPopoverItems: records,
                                                                                })}
                                                                            />
                                                                        </Tooltip>
                                                                    );
                                                                })()}
                                                            </CustomTableCell>
                                                            {contact_fields
                                                                .filter((cf) => cf.is_global)
                                                                .map((cf) => {
                                                                    var userinput = null;
                                                                    n.columns.forEach(function (fi) {
                                                                        if (fi.field_name === cf.field_name) userinput = fi.userinput;
                                                                    });

                                                                    if (cf.field_type === "Phone Number") {
                                                                        return (
                                                                            <CustomTableCell key={cf.id}>
                                                                                <NumberFormat
                                                                                    format="+1 (###) ###-####"
                                                                                    allowEmptyFormatting
                                                                                    mask="_"
                                                                                    displayType={"text"}
                                                                                    value={userinput ? userinput : "-"}
                                                                                />
                                                                            </CustomTableCell>
                                                                        );
                                                                    } else if (cf.field_type === "Yes/No") {
                                                                        return (
                                                                            <CustomTableCell key={cf.id}>
                                                                                {userinput === "" || userinput === "false" ? "No" : "Yes"}
                                                                            </CustomTableCell>
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <Tooltip title={userinput || ""}>
                                                                                <CustomTableCell key={cf.id}>
                                                                                    <div className={classes.truncate}>
                                                                                        {userinput}
                                                                                    </div>
                                                                                </CustomTableCell>
                                                                            </Tooltip>
                                                                        );
                                                                    }
                                                                })}
                                                        </TableRow>
                                                    );
                                                })}
                                            {(searchingcount < 1 || searching.length < 1) && (
                                                <TableRow>
                                                    <CustomTableCell colSpan={columnData.length} className={classes.centerAlign}>
                                                        No Contacts Found
                                                    </CustomTableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        {searchingcount > 25 && (
                                            <TableFooter>
                                                <TableRow>
                                                    <TablePagination
                                                        colSpan={columnData.length}
                                                        count={searchingcount}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={this.handleChangePage}
                                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                        ActionsComponent={TablePaginationActionsWrapped}
                                                    />
                                                </TableRow>
                                            </TableFooter>
                                        )}
                                    </Table>
                                </div>
                            </Grid>
                        </>
                    )}
                </Grid>

                <Dialog open={this.state.exportLoading} disableEscapeKeyDown>
                    <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "32px 48px", gap: 16 }}>
                        <CircularProgress size={40} />
                        <DialogContentText style={{ margin: 0 }}>Please wait...</DialogContentText>
                    </DialogContent>
                </Dialog>

                <Popover
                    open={Boolean(recordsPopoverAnchor)}
                    anchorEl={recordsPopoverAnchor}
                    onClose={() => this.setState({ recordsPopoverAnchor: null, recordsPopoverItems: [] })}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
                    <div style={{ padding: '8px 16px', maxHeight: 300, overflowY: 'auto', minWidth: 220 }}>
                        {recordsPopoverItems.map((record, i) => (
                            <div key={i} style={{ padding: '4px 0' }}>
                                <a
                                    href={record.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#1976d2', textDecoration: 'underline', fontSize: 13 }}>
                                    {record.label}
                                </a>
                            </div>
                        ))}
                    </div>
                </Popover>

                <ContactDialog
                    closeDialog={(wasSaved = true) => {
                        const { newContactId, page, rowsPerPage, order, orderBy } = this.state;
                        const { ormContactRecordDelete } = this.props;
                        // Ideally we would refresh the table but the 2 second delay is janky
                        /*const comp = this;
                        setTimeout(function() {
                            comp.dynamicLoading(page, rowsPerPage, order, orderBy);
                        }, 2000);*/
                        // if (goBack) history.goBack();
                        const refresh = () => {
                            this.loadTotalRecords();
                            this.dynamicLoading(page, rowsPerPage, order, orderBy);
                            if (this.state.lastSearchValues) {
                                this.searchForm(this.state.lastSearchValues);
                            }
                            this.setState({
                                dialogOpen: false,
                                activeContact: null,
                                newContactId: null,
                            });
                        };
                        if (wasSaved === false && newContactId) {
                            ormContactRecordDelete(newContactId).then(() => {
                                refresh();
                            }).catch(() => {
                                refresh();
                            });
                        } else {
                            refresh();
                        }
                    }}
                    authState={authState}
                    activeContact={activeContact}
                    contact_fields={contact_fields}
                    ormContactRecordFieldUpdate={ormContactRecordFieldUpdate}
                    dialogOpen={dialogOpen}
                />

                <WarningDialog
                    confirmAction={() => {
                        ormContactRecordDelete(deleteDialogConfirmAction);
                        const comp = this;
                        setTimeout(function () {
                            comp.loadTotalRecords();
                        }, 1000);
                        this.setState({ deleteDialogOpen: false });
                    }}
                    cancelAction={() => this.setState({ deleteDialogOpen: false })}
                    open={deleteDialogOpen}
                    title="Delete Contact"
                    text="Are you sure you wish to delete this contact? Deleting this contact will also remove it from any other record."
                />
                <FormUpload
                    authState={authState}
                    classes={classes}
                    authLogout={authLogout}
                    open={open}
                    returnDialog={() => {
                        this.loadTotalRecords();
                        this.setState({ open: false });
                    }}
                    history={history}
                />
            </AppContainer>
        );
    }
}

class FormUpload extends Component {
    state = {
        loading: false,
        results: null,
    };
    formKey = window.performance.now();

    uploadDocument = (values, formApi) => {
        var { authState, history, authLogout } = this.props;
        this.setState({ loading: true, results: null });
        fetch("/excel/contacts/import", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": getCSRFToken(),
            },
            body: JSON.stringify(values),
        }).then((e) => {
            if (e.status === 401 || e.status === 403) {

                authLogout(authState, history);
            } else if (e.status === 500) {
                let msg = "<b>Upload Failed</b><br/>";
                this.setState({ loading: false, results: msg });
            } else {
                var msg;
                e.json()
                    .then((data) => {
                        msg = "<b>Upload Results:</b><br/>";
                        data.message.forEach(function (m) {
                            msg += m.name + ": " + m.message + "<br/>";
                        });
                        formApi.resetAll();
                        this.formKey = window.performance.now();
                    })
                    .then(() => {
                        this.setState({ loading: false, results: msg });
                    });
            }
        });
    };

    errorValidator = (values) => {
        const isRequired = (val) => {
            return !val ? "Required" : null;
        };
        var valObj = {
            file: isRequired(values.file),
        };

        return valObj;
    };

    closeDialog = () => {
        const { returnDialog } = this.props;

        this.setState({ results: null, loading: false });
        returnDialog();
    };

    render() {
        const { classes, open } = this.props;
        const { loading, results } = this.state;

        return (
            <Dialog open={open} classes={{ paper: classes.minWidth2 }}>
                <Toolbar style={{ backgroundColor: "#d3d3d3" }}>
                    <Typography variant="h5" className={classes.flex}>
                        Upload Master Contacts
                    </Typography>
                    <IconButton
                        aria-label="Close Dialog"
                        onClick={this.closeDialog}
                    >
                        <Close />
                    </IconButton>
                </Toolbar>
                <DialogContent>
                    <DialogContentText>
                        <Form
                            key={this.formKey}
                            dontValidateOnMount={true}
                            validateOnSubmit={true}
                            validateError={this.errorValidator}
                            onSubmit={(values, e, formApi) => this.uploadDocument(values, formApi)}>
                            {(formApi) => (
                                <form onSubmit={formApi.submitForm}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <FileInput
                                                field="file"
                                                id="file_upl"
                                                fullWidth
                                                label={
                                                    <HelpLabel
                                                        inputLabel="Field Spreadsheet"
                                                        helpText="Upload an Excel spreadsheet (.xlsx) containing your contacts on each row. The column names should match the spreadsheet generated from the <strong><u>Export All Contacts (use for import)</u></strong> button."
                                                    />
                                                }
                                            />
                                            <Switch
                                                field="delete_current"
                                                name="delete_current"
                                                label={
                                                    <HelpLabel
                                                        inputLabel="Remove All Existing Master Contacts?"
                                                        helpText="Select Yes to overwrite any existing contacts prior to uploading these new fields. Warning: Deletion of contacts is permanent and contacts will be removed from existing records."
                                                    />
                                                }
                                            />
                                            {loading && (
                                                <CircularProgress size={24} style={{ display: "table", marginLeft: "auto", marginRight: "auto" }} />
                                            )}
                                            {results && (
                                                <Typography style={{ textAlign: "center" }}>
                                                    <div dangerouslySetInnerHTML={{ __html: results }} />
                                                </Typography>
                                            )}
                                            {!loading && (
                                                <>
                                                    <Button type="submit" variant="raised" color="primary" className={classes.floatLeft}>
                                                        Upload
                                                    </Button>
                                                    <Button
                                                        onClick={this.closeDialog}
                                                        type="button"
                                                        variant="raised"
                                                        color="primary"
                                                        className={classes.floatRight}>
                                                        Close
                                                    </Button>
                                                </>
                                            )}
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Form>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }
}
Contacts.displayName = "Contacts";

Contacts = connect(
    (state, ownProps) => ({
        contact_fields: getContactFields(state, ownProps),
        master_contacts: getMasterContacts(state, ownProps),
        authState: state.auth,
    }),
    {
        ...ContactField.actions,
        ...ContactRecordField.actions,
        ...ContactRecord.actions,
        ...authActions,
    }
)(Contacts);

export default withStyles(styles)(withRouter(Contacts));
